import React from 'react';
import styled from 'styled-components';
import { Grid, Box, Text } from '@flexisaf/flexibull2';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import PropTypes from 'prop-types';
import { EMPTY_VALUE } from 'utils/constants';

const NinWrapper = styled.div`
  margin: 24px;
  max-width: 900px;
  & .candidate-img-box {
    width: 120px;
    height: 120px;
    padding: 8px;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    & img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
`;

const formatValue = (value) => {
  if (value == null || value === '') return null;
  if (Array.isArray(value) && value.length >= 3) {
    const [y, m, d] = value;
    return `${y}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
  }
  return value;
};

const Field = ({ label, value }) => (
  <Box className="single-form" pad="0 0 12px">
    <Text color={({ theme }) => theme.PrimaryInputOutline} uppercase bold block>
      {label}
    </Text>
    <Text>{formatValue(value) || EMPTY_VALUE}</Text>
  </Box>
);

Field.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

const NinResult = ({ loading, ninInfo }) => {
  if (loading) {
    return (
      <Box width="100%" pad="0px 24px" vAlign>
        <Box width="100%" margin="30px 0" align="center">
          <SkeletonTheme color="#d0d5d933" highlightColor="#c2cad133">
            <Skeleton count={4} height={40} />
          </SkeletonTheme>
        </Box>
      </Box>
    );
  }

  if (!ninInfo?.length) {
    return null;
  }

  return (
    <div>
      {ninInfo.map((row, i) => {
        const result = row?.result || row;
        return (
          <NinWrapper key={row.id || i}>
            <Text block bold size="16px" uppercase>
              NIN Verification {ninInfo.length > 1 ? `(${i + 1})` : ''}
            </Text>
            <Box pad="10px" />
            {result?.photoBase64 && (
              <Box className="candidate-img-box">
                <img src={result.photoBase64} alt="Verified identity" />
              </Box>
            )}
            <Box pad="10px" />
            <Grid className="form-grid" default="1fr 1fr 1fr" gap="0px">
              <Field label="First Name" value={result?.firstName} />
              <Field label="Middle Name" value={result?.middleName} />
              <Field label="Last Name" value={result?.lastName} />
              <Field label="Gender" value={result?.gender} />
              <Field label="Date of Birth" value={result?.dateOfBirth} />
              <Field label="State" value={result?.state} />
              <Field label="LGA" value={result?.lga} />
              <Field
                label="NIN (last 4)"
                value={result?.ninLast4 ? `****${result.ninLast4}` : null}
              />
            </Grid>
          </NinWrapper>
        );
      })}
    </div>
  );
};

NinResult.propTypes = {
  loading: PropTypes.bool,
  ninInfo: PropTypes.array,
};

NinResult.defaultProps = {
  loading: false,
  ninInfo: [],
};

export default NinResult;
